@if (isLoading && images.length && !currentImage?.IsVideo) {
<div class="loader" @enterLeaveFadeAnimation>
  <div class="spin-stretch"></div>
</div>
}
<header [ngClass]="{'has-title': showTitle && currentImage?.Title, 'has-inventory-home-label': isInventoryHomeGallery}"
        [class.top-header-controls]="topControls">
  @if (showTitle && currentImage?.Title) {
  <div class="title">{{currentImage.Title}}</div>
  }
  @if (isInventoryHomeGallery) {
  <div class="inventory-home-label">{{ theme.inventoryHomeLabel }}</div>
  }
</header>

<div class="swipe-container">
  <div class="swipe-wrapper" gallerySwiper [index]="selectedIndex" [slideCount]="images.length" (indexChange)="handleSwipeIndexChange($event)">
    @for (item of images; track item.Id; let i = $index) {
    <div class="image-slide">
      @if (item.HasLoadedOnce || (selectedIndex - 1 <= i && i <=selectedIndex + 1)) { <!-- -->
        @if (!item.IsVideo && !item.IsIframe && !item.InnerHtml) { <img [src]="getImageSrc(item)" (load)="onResourceLoadOrError(item)"
             [alt]="item.Title || altText + (i + 1)" (error)="onResourceLoadOrError(item)"
             [class.fit-contain]="item.Type === types.Floor || useLetterbox" @enterLeaveFadeAnimation>
        }
        @if (item.InnerHtml) {
        <div class="html-container" [innerHTML]="item.InnerHtml | safeHtml"></div>
        }
        @if (item?.IsIframe) {
        <iframe [src]="item.FullUrl | safeUrl" (load)="onResourceLoadOrError(item)"></iframe>
        }
        @if (item?.IsVideo) {
        <video-with-preview [src]="item.FullUrl" [previewUrl]="item.ThumbnailUrl" @enterLeaveFadeAnimation>
        </video-with-preview>
        }
        }
    </div>
    }
  </div>
</div>
@if (images.length > 1 && showControls || topControls) {
<div class="gallery-controls" [class.top-controls]="topControls">
  @if (topControls && images.length > 1 || !topControls) {
  <icon-button [class.btn-background]="buttonBkgEnabled" icon="carrot_arrow" class="left-arrow" (click)="goToImage(selectedIndex - 1, true)"
               ariaLabel="Previous">
  </icon-button>
  }
  @if (topControls && images.length > 1 || !topControls) {
  <div class="pager">
    <p class="page-number">
      {{selectedIndex + 1}} / {{images.length}}
    </p>
  </div>
  }
  @if (topControls && images.length > 1 || !topControls) {
  <icon-button [class.btn-background]="buttonBkgEnabled" icon="carrot_arrow" class="right-arrow" [class.top-screen]="topControls"
               (click)="goToImage(selectedIndex + 1, true)" ariaLabel="Next">
  </icon-button>
  }
  @if (topControls && currentImage) {
  <icon-button class="fullscreen-btn" [class.btn-background]="buttonBkgEnabled" icon="fullscreen_enter" (click)="goToFullscreen()"
               ariaLabel="Full Screen">
  </icon-button>
  }
</div>
}
@if(showFavoriteBtn) {
@if (!disableFavoriting && currentImage?.IsFavoritable) {
<favorite-btn [isActive]="currentImage?.IsFavorited" (toggle)="handleFavoriteToggle($event)"
              [ngClass]="favButtonPlacement === 'Right' ? 'button-right' : 'button-left'">
</favorite-btn>
}
}
@if(showFullscreenBtn) {
@if (currentImage && !topControls) {
<icon-button class="fullscreen-btn" [class.btn-background]="buttonBkgEnabled" icon="fullscreen_enter"
             [ngClass]="favButtonPlacement === 'Right' ? 'button-left' : 'button-right'" (click)="goToFullscreen()" ariaLabel="Full Screen">
</icon-button>
}
}
